import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { ToastService } from '../../services/toast.service';
import { ConfirmService } from '../../services/confirm.service';
import { Cliente } from '../../models';

@Component({
  selector: 'app-clienti',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="page-container">
      <div class="header-flex">
        <div>
          <h1>Gestione Clienti</h1>
          <p class="subtitle">Anagrafica clienti e contatti</p>
        </div>
        <button class="btn-primary" (click)="openModal()">
          <span class="material-icons" style="font-size: 18px;">person_add</span> Nuovo Cliente
        </button>
      </div>

      <!-- Search Bar -->
      <div class="search-bar card">
        <span class="material-icons search-icon">search</span>
        <input type="text" [(ngModel)]="searchTerm" placeholder="Cerca per nome, cognome, email o telefono..." />
        <button *ngIf="searchTerm" class="btn-clear" (click)="searchTerm = ''">Cancella</button>
      </div>

      <!-- Desktop Table View -->
      <div class="card table-card desktop-only">
        <table class="data-table">
          <thead>
            <tr>
              <th>Nome e Cognome</th>
              <th>Telefono</th>
              <th>Email</th>
              <th>Indirizzo</th>
              <th style="text-align: right;">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of filteredClienti">
              <td>
                <div class="client-name">
                  <div class="avatar-sm">{{ c.cognome.charAt(0) }}{{ c.nome.charAt(0) }}</div>
                  <strong>{{ c.cognome }} {{ c.nome }}</strong>
                </div>
              </td>
              <td>{{ c.telefono || '-' }}</td>
              <td>{{ c.email || '-' }}</td>
              <td>{{ c.indirizzo || '-' }}</td>
              <td style="text-align: right;">
                <button class="btn-sm" (click)="editCliente(c)" title="Modifica">
                  <span class="material-icons" style="font-size: 16px;">edit</span>
                </button>
                <button class="btn-sm btn-danger" (click)="deleteCliente(c.id!)" title="Elimina">
                  <span class="material-icons" style="font-size: 16px;">delete</span>
                </button>
              </td>
            </tr>
            <tr *ngIf="filteredClienti.length === 0">
              <td colspan="5" class="text-center">Nessun cliente trovato.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Card View -->
      <div class="mobile-only mobile-card-list">
        <div class="mobile-item-card card" *ngFor="let c of filteredClienti">
          <div class="mobile-card-header">
            <div class="client-name">
              <div class="avatar-sm">{{ c.cognome.charAt(0) }}{{ c.nome.charAt(0) }}</div>
              <strong>{{ c.cognome }} {{ c.nome }}</strong>
            </div>
            <div class="mobile-actions">
              <button class="btn-sm" (click)="editCliente(c)" title="Modifica"><span class="material-icons" style="font-size: 16px;">edit</span></button>
              <button class="btn-sm btn-danger" (click)="deleteCliente(c.id!)" title="Elimina"><span class="material-icons" style="font-size: 16px;">delete</span></button>
            </div>
          </div>
          <div class="mobile-card-body">
            <p *ngIf="c.telefono">📞 <a [href]="'tel:' + c.telefono" class="mobile-contact-link">{{ c.telefono }}</a></p>
            <p *ngIf="c.email">✉️ <a [href]="'mailto:' + c.email" class="mobile-contact-link">{{ c.email }}</a></p>
            <p *ngIf="c.indirizzo">📍 <a [href]="'https://maps.google.com/?q=' + encodeURIComponent(c.indirizzo)" target="_blank" class="mobile-contact-link">{{ c.indirizzo }}</a></p>
          </div>
          <div class="mobile-card-quick-btns" *ngIf="c.telefono || c.indirizzo">
            <a *ngIf="c.telefono" [href]="'tel:' + c.telefono" class="btn-quick-action btn-call">
              <span class="material-icons" style="font-size: 16px;">phone</span> Chiama
            </a>
            <a *ngIf="c.indirizzo" [href]="'https://maps.google.com/?q=' + encodeURIComponent(c.indirizzo)" target="_blank" class="btn-quick-action btn-map">
              <span class="material-icons" style="font-size: 16px;">map</span> Mappa
            </a>
          </div>
        </div>
        <div class="text-center" *ngIf="filteredClienti.length === 0">Nessun cliente trovato.</div>
      </div>

      <!-- Modal -->
      <div class="modal-backdrop" *ngIf="showModal">
        <div class="modal-card">
          <h2>{{ editingId ? 'Modifica Cliente' : 'Nuovo Cliente' }}</h2>
          <form (ngSubmit)="saveCliente()">
            <div class="form-row">
              <div class="form-group">
                <label>Nome *</label>
                <input type="text" [(ngModel)]="currentCliente.nome" name="nome" required placeholder="Es. Mario" />
              </div>
              <div class="form-group">
                <label>Cognome *</label>
                <input type="text" [(ngModel)]="currentCliente.cognome" name="cognome" required placeholder="Es. Rossi" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>Telefono</label>
                <input type="text" [(ngModel)]="currentCliente.telefono" name="telefono" placeholder="Es. 333 1234567" />
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="email" [(ngModel)]="currentCliente.email" name="email" placeholder="Es. mario@email.com" />
              </div>
            </div>
            <div class="form-group">
              <label>Indirizzo</label>
              <input type="text" [(ngModel)]="currentCliente.indirizzo" name="indirizzo" placeholder="Es. Via Roma 10, Brescia" />
            </div>
            <div class="form-group">
              <label>Note</label>
              <textarea [(ngModel)]="currentCliente.nota" name="nota" rows="3" placeholder="Eventuali note sul cliente..."></textarea>
            </div>
            <div class="modal-actions">
              <button type="button" class="btn-secondary" (click)="closeModal()">Annulla</button>
              <button type="submit" class="btn-primary">Salva Cliente</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .page-container { max-width: 1280px; margin: 0 auto; }
    .header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; gap: 12px; }
    h1 { margin: 0; color: var(--text-main); font-size: 26px; font-weight: 700; letter-spacing: -0.5px; }
    .subtitle { color: var(--text-muted); margin: 4px 0 0; font-size: 14px; }
    
    .search-bar { display: flex; align-items: center; gap: 12px; padding: 12px 20px; margin-bottom: 24px; border-radius: 12px; }
    .search-bar .search-icon { color: var(--text-muted); }
    .search-bar input { border: none; background: transparent; font-size: 15px; width: 100%; color: var(--text-main); outline: none; }
    .btn-clear { background: var(--border); border: none; padding: 4px 10px; border-radius: 6px; cursor: pointer; font-size: 12px; color: var(--text-muted); }

    .table-card { padding: 0; overflow: hidden; border-radius: 12px; border: 1px solid var(--border); }
    .data-table { width: 100%; border-collapse: collapse; text-align: left; }
    .data-table th, .data-table td { padding: 16px 20px; border-bottom: 1px solid var(--border); font-size: 14px; }
    .data-table th { background: var(--bg-main); color: var(--text-muted); font-weight: 600; text-transform: uppercase; font-size: 12px; letter-spacing: 0.5px; }
    .data-table tbody tr { transition: background 0.15s; }
    .data-table tbody tr:hover { background: var(--bg-main); }
    
    .client-name { display: flex; align-items: center; gap: 12px; }
    .avatar-sm { width: 34px; height: 34px; background: var(--primary-light); color: var(--primary); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 12px; }
    
    .btn-primary { display: inline-flex; align-items: center; gap: 6px; background: var(--primary); color: white; border: none; padding: 10px 18px; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px; transition: background 0.2s; box-shadow: 0 2px 4px rgba(37,99,235,0.2); }
    .btn-primary:hover { background: var(--primary-dark); }
    .btn-secondary { background: var(--bg-main); color: var(--text-main); border: 1px solid var(--border); padding: 10px 18px; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px; }
    .btn-secondary:hover { background: var(--border); }
    
    .btn-sm { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 6px; border: 1px solid var(--border); background: var(--surface); color: var(--text-muted); cursor: pointer; transition: all 0.2s; margin-right: 6px; }
    .btn-sm:hover { background: var(--bg-main); color: var(--text-main); }
    .btn-danger { background: rgba(239, 68, 68, 0.1); border-color: rgba(239, 68, 68, 0.2); color: var(--danger); }
    .btn-danger:hover { background: var(--danger); color: white; }
    
    .text-center { text-align: center; color: var(--text-muted); padding: 40px !important; }

    /* Mobile Card List */
    .mobile-only { display: none !important; }
    .desktop-only { display: block !important; }
    .mobile-card-list { display: flex; flex-direction: column; gap: 12px; }
    .mobile-item-card { padding: 16px; display: flex; flex-direction: column; gap: 10px; }
    .mobile-card-header { display: flex; justify-content: space-between; align-items: center; }
    .mobile-card-body p { margin: 6px 0; font-size: 13px; color: var(--text-muted); }
    .mobile-contact-link { color: var(--primary); font-weight: 600; text-decoration: none; }
    .mobile-contact-link:hover { text-decoration: underline; }
    .mobile-actions { display: flex; gap: 6px; }
    .mobile-card-quick-btns { display: flex; gap: 8px; margin-top: 12px; padding-top: 10px; border-top: 1px solid var(--border); }
    .btn-quick-action { flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; border-radius: 8px; font-size: 12px; font-weight: 700; text-decoration: none; transition: opacity 0.2s; }
    .btn-call { background: rgba(13, 148, 136, 0.12); color: var(--success); border: 1px solid rgba(13, 148, 136, 0.3); }
    .btn-map { background: rgba(37, 99, 235, 0.12); color: #2563eb; border: 1px solid rgba(37, 99, 235, 0.3); }
    .btn-quick-action:hover { opacity: 0.85; }

    /* Modal */
    .modal-backdrop { 
      position: fixed; 
      top: 0; 
      left: 0; 
      right: 0;
      bottom: 0;
      width: 100vw; 
      height: 100vh; 
      box-sizing: border-box;
      background: rgba(15, 23, 42, 0.65); 
      display: flex; 
      justify-content: center; 
      align-items: center; 
      z-index: 9999; 
    }
    .modal-card { 
      background: var(--surface); 
      padding: 32px; 
      border-radius: 16px; 
      width: 100%; 
      max-width: 560px; 
      box-shadow: var(--shadow-lg); 
      border: 1px solid var(--border); 
      box-sizing: border-box;
    }
    .modal-card h2 { margin-top: 0; margin-bottom: 24px; color: var(--text-main); font-size: 20px; font-weight: 700; }
    .form-row { display: flex; gap: 16px; }
    .form-group { margin-bottom: 18px; flex: 1; }
    label { display: block; margin-bottom: 6px; font-weight: 600; font-size: 13px; color: var(--text-main); }
    input, textarea { width: 100%; padding: 11px 14px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; box-sizing: border-box; background: var(--bg-main); transition: all 0.2s; color: var(--text-main); }
    input:focus, textarea:focus { border-color: var(--primary); outline: none; background: var(--surface); box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15); }
    .modal-actions { display: flex; justify-content: flex-end; gap: 14px; margin-top: 28px; }

    @media (max-width: 768px) {
      .desktop-only { display: none !important; }
      .mobile-only { display: flex !important; }

      .modal-backdrop {
        padding: 16px !important;
        align-items: center !important;
        overflow-y: auto !important;
      }
      .modal-card {
        padding: 22px 18px !important;
        max-height: none !important;
        overflow: visible !important;
        border-radius: 20px !important;
        width: 100% !important;
        box-sizing: border-box !important;
        margin: auto !important;
      }
      input, select, textarea {
        font-size: 16px !important; /* Previene auto-zoom e disallineamenti mobile */
      }
      .form-row {
        flex-direction: column !important;
        gap: 0 !important;
      }
      .modal-actions {
        flex-direction: column-reverse;
        gap: 14px;
        margin-top: 22px;
      }
      .modal-actions button {
        width: 100%;
        margin: 0;
      }
    }
  `]
})
export class ClientiComponent implements OnInit {
  clienti: Cliente[] = [];
  searchTerm = '';
  showModal = false;
  editingId: number | null = null;
  currentCliente: Cliente = { nome: '', cognome: '' };

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private confirmService: ConfirmService
  ) {}

  encodeURIComponent(str: string): string {
    return encodeURIComponent(str || '');
  }

  ngOnInit() {
    this.loadClienti();
  }

  get filteredClienti(): Cliente[] {
    if (!this.searchTerm.trim()) return this.clienti;
    const term = this.searchTerm.toLowerCase();
    return this.clienti.filter(c =>
      c.nome.toLowerCase().includes(term) ||
      c.cognome.toLowerCase().includes(term) ||
      (c.email && c.email.toLowerCase().includes(term)) ||
      (c.telefono && c.telefono.toLowerCase().includes(term))
    );
  }

  loadClienti() {
    this.apiService.getClienti().subscribe({
      next: (data) => this.clienti = data,
      error: (err) => console.error('Errore caricamento clienti', err)
    });
  }

  openModal() {
    this.editingId = null;
    this.currentCliente = { nome: '', cognome: '' };
    this.showModal = true;
  }

  editCliente(c: Cliente) {
    this.editingId = c.id!;
    this.currentCliente = { ...c };
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  saveCliente() {
    if (!this.currentCliente.nome || !this.currentCliente.cognome) {
      this.toastService.warning('Nome e Cognome sono obbligatori');
      return;
    }

    if (this.editingId) {
      this.apiService.updateCliente(this.editingId, this.currentCliente).subscribe({
        next: () => {
          this.toastService.success('Cliente aggiornato con successo');
          this.loadClienti();
          this.closeModal();
        },
        error: (err) => this.toastService.error(err.error?.error || 'Errore durante aggiornamento cliente')
      });
    } else {
      this.apiService.createCliente(this.currentCliente).subscribe({
        next: () => {
          this.toastService.success('Cliente creato con successo');
          this.loadClienti();
          this.closeModal();
        },
        error: (err) => this.toastService.error(err.error?.error || 'Errore durante creazione cliente')
      });
    }
  }

  async deleteCliente(id: number) {
    const confirmed = await this.confirmService.confirm(
      'Elimina Cliente',
      'Sei sicuro di voler eliminare questo cliente?',
      'Elimina',
      'Annulla',
      true
    );
    if (confirmed) {
      this.apiService.deleteCliente(id).subscribe({
        next: () => {
          this.toastService.success('Cliente eliminato');
          this.loadClienti();
        },
        error: (err) => this.toastService.error(err.error?.error || 'Errore durante eliminazione')
      });
    }
  }
}
